import type { DonationForm } from '@kuow/core';

type AssetRef = { cdn_url?: string; src?: string } | null | undefined;

export const getAssetUrl = (asset: AssetRef): string | null => {
  if (!asset) return null;
  const url = (asset.cdn_url ?? asset.src ?? '').trim();
  return url ? url : null;
};

export const getThemeContentString = (content: Record<string, unknown> | null | undefined, key: string): string | null => {
  if (!content) return null;
  const value = content[key];
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed ? trimmed : null;
};

export const buildImgixUrl = (baseUrl: string, params: Record<string, string | number>): string => {
  const url = new URL(baseUrl);
  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.set(key, String(value));
  });
  return url.toString();
};

export const getImpactContent = (formDetails: DonationForm | null) => {
  const impactHeadline = getThemeContentString(formDetails?.theme_content ?? null, 'impact_headline');
  const impactBullets = [
    getThemeContentString(formDetails?.theme_content ?? null, 'impact_bullet1'),
    getThemeContentString(formDetails?.theme_content ?? null, 'impact_bullet2'),
    getThemeContentString(formDetails?.theme_content ?? null, 'impact_bullet3'),
    getThemeContentString(formDetails?.theme_content ?? null, 'impact_bullet4'),
  ].filter((value): value is string => Boolean(value));

  return {
    impactHeadline,
    impactBullets,
    hasImpactSection: Boolean(impactHeadline ?? impactBullets[0]),
  };
};
